import React from "react";

import * as styles from "./footer.css";
import { Paper, Typography } from "@mui/material";
import Link from "next/link";
import { clsx } from "../../uikit/utils";
import { link } from "styles/globals.css";

const Footer = () => {
  return (
    <Paper component="footer" className={styles.footer}>
      <div className={styles.footerContent}>
        <Typography align="center">
          Copyright © 2025 Stat Analyzer Ltd.
        </Typography>
        <div>
          <Link
            className={clsx(link, styles.link, styles.linkBorder)}
            href="/about"
          >
            About
          </Link>
          <Link
            className={clsx(link, styles.link, styles.linkBorder)}
            href="/terms"
          >
            Terms
          </Link>
          <Link className={clsx(link, styles.link)} href="/privacy">
            Privacy
          </Link>
        </div>
      </div>
    </Paper>
  );
};

export default Footer;
